import React, { useState } from "react";
import { Tabs } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import SubjectHistoreyData from "./SubjectHistoreyData";
import DashboardWrapper from "../shared/DashboardWrapper";
import "../alltest/allStudentTest.css";

const Student = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [tabKey, setTabKey] = useState("Mathematics");

  // Redux state (placeholder for future use)
  // const admin = useSelector((state) => state.admin);
  // const trainer = useSelector((state) => state.trainer);
  // const trainee = useSelector((state) => state.trainee);

  const subjects = ["Mathematics", "English", "Science"];

  const tabItems = [
    ...subjects.map((subject) => ({
      key: subject,
      label: subject.toUpperCase(),
      children: <SubjectHistoreyData title={subject} />,
    })),
    {
      key: "MotherTongue",
      label: "MOTHER TONGUE",
      children: <p style={{ padding: 16 }}>No data available</p>,
    },
  ];

  return (
    <DashboardWrapper title="TEST HISTORY">
      <div className="tabs">
        <Tabs
          activeKey={tabKey}
          onChange={setTabKey}
          items={tabItems}
          tabBarStyle={{ borderBottom: 0 }}
          destroyOnHidden
        />
      </div>
    </DashboardWrapper>
  );
};

export default Student;
